import * as React from "react";
import nameof from "ts-nameof.macro";

import { Col, FormGroup, Label, Input } from "reactstrap";

import { CompromisosService } from "./CompromisosService";
import { I18n } from "../utils/I18n";
import { ColegioUsuariosSearch, CompromisoListItem, CompromisoListItemPaginatedList, CompromisosSearch, YesNo } from "../models/dataModels";
import { IServiceForIndex } from "../utils/base/BaseServices";
import { IndexPageBase, TableColumn } from "../utils/base/IndexPageBase";
import { ClientContext } from "../utils/ClientContext";
import { Link, withRouter } from "react-router-dom";
import { ModelValidation } from "../utils/base/ModelValidation";
import { YesNoDropDown } from "../helpers/EnumDropDown";
import { YesNoCancelModal } from "../utils/YesNoCancelModal";


export interface CompromisosSearchEx extends CompromisosSearch {
    compromisoAceptar: CompromisoListItem;
}

class IndexComp extends IndexPageBase<CompromisosSearchEx, CompromisoListItemPaginatedList, CompromisoListItem>
{
    protected _getInitialSearchParams() {

        // TODO: Poner las campañas en un dropdown para poder elegir la campaña a mostrar. Por ahora se muestra la activa
        var searchModel = super._getInitialSearchParams();
        searchModel.campannaId = 2026; //ClientContext.getCampannaActiva();
        searchModel.rowsPerPage = 100;
        return searchModel;
    }

    protected _getPageTitle(): string {
        return "Compromisos"
    }
    protected _getPageDescription(): string {
        return "Puede ver y aceptar todos los compromisos acordados para el colegio";
    }

    protected _renderSearchForm(): React.ReactNode {
        return <React.Fragment>

            {this.state.searchParams.compromisoAceptar != undefined && <YesNoCancelModal
                NoText="Cancelar"
                YesText="Aceptar"
                confirmTitle="Aceptar compromiso"
                confirmBody={`¿Está seguro de que desea aceptar el compromiso "${this.state.searchParams.compromisoAceptar.tituloPublicado}."? Una vez que se acepte no podrá desmarcarlo.`}
                onYes={() => {
                    this.aceptarCompromiso(this.state.searchParams.compromisoAceptar, true);
                }}
                onCancel={() => {
                    var state = this._cloneStateForSetState();
                    state.showLoadingIcon = false;
                    state.searchParams.compromisoAceptar = null;
                    this.setState(state, () => this._performSearch());
                }}
                onNo={() => {
                    var state = this._cloneStateForSetState();
                    state.showLoadingIcon = false;
                    state.searchParams.compromisoAceptar = null;
                    this.setState(state, () => this._performSearch());
                }}
            />}
            {ClientContext.Current.cursosEscolares && <>

                <Col md={3}>
                    <YesNoDropDown
                        label={I18n.Strings.compromisos.mostrarPendientesDeAceptar}
                        showLabel={true}
                        id={"compromisos" + nameof(this.state.searchParams.mostrarPendientesDeAceptar)}
                        value={this.state.searchParams.mostrarPendientesDeAceptar == null ? null : this.state.searchParams.mostrarPendientesDeAceptar ? YesNo.Yes.toString() : YesNo.No.toString()}
                        className={"form-control"}
                        required={true}
                        onChanged={(value: YesNo) => {
                            var newState = this._cloneStateForSetState();
                            newState.searchParams.mostrarPendientesDeAceptar = value == YesNo.Yes.toString() ? true : value == YesNo.No.toString() ? false : null;
                            this.setState(newState);
                        }}
                    />
                </Col>
            </>}
            {/* ClientContext.Current.cursosEscolares && <>
                <Col xs="12" md="2" lg="2">
                    <FormGroup>
                        <Label className="form-label" for={"compromisos" + nameof(this.state.searchParams.campannaId)}>
                            {I18n.Strings.compromisos.campanna}
                        </Label>
                        <select
                            id={"compromisos" + nameof(this.state.searchParams.campannaId)}
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.searchParams.campannaId = parseInt(evt.target.value);
                                this.setState(state);
                            }}
                            className="form-select"
                        >
                            {ClientContext.Current.cursosEscolares.map((item, index) => {
                                    return <option
                                        key={index}
                                        value={item.campanna}
                                    >
                                        {item.campannaId.toString()} - {(item.campannaId + 1).toString()}
                                    </option>
                                })
                            }
                        </select>
                    </FormGroup>
                </Col>
            </>*/}

        </React.Fragment>;
    }

    protected _getApiService(): IServiceForIndex<CompromisosSearch, CompromisoListItemPaginatedList> {
        return new CompromisosService();
    }

    getResponsables(item: CompromisoListItem) {
        const responsables = [];
        if (item.responsableAtc) { responsables.push("ATC"); }
        if (item.responsableComercial) { responsables.push("Comercial"); }
        if (item.responsableColegio) { responsables.push("Colegio"); }
        return responsables.join(", ") || " - ";
    };

    aceptarCompromiso(item: CompromisoListItem, aceptado: boolean) {
        this.setState({ showLoadingIcon: true }, () => {
            var service = new CompromisosService();
            service.aceptarCompromiso({
                compromisoId: item.id,
                colegioId: ClientContext.Current.colegioId,
                aceptado: aceptado
            })
                .then((ret) => {
                    var state = this._cloneStateForSetState();
                    state.showLoadingIcon = false;
                    state.searchParams.compromisoAceptar = null;
                    this.setState(state, () => this._performSearch());
                });
        })
    }

    protected _getTableColumns(): TableColumn<CompromisoListItem>[] {

        var columns = [
            {
                fieldName: nameof(this.state.searchResults.items[0].tipoCompromiso),
                title: I18n.Strings.compromisos.tipo,
                renderField: (item: CompromisoListItem) => item.tipoCompromiso
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].tituloPublicado),
                title: I18n.Strings.compromisos.titulo,
                renderField: (item: CompromisoListItem) => item.tituloPublicado
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].descripcionPublicado),
                title: I18n.Strings.compromisos.descripcion,


                renderField: (item: CompromisoListItem) => {
                    var texto = item.descripcionPublicado;
                    // Check if texto contains HTML tags
                    const hasHtml = /<\/?[a-z][\s\S]*>/i.test(texto);
                    if (!hasHtml && texto) {
                        texto = texto.replace(/\n/g, "<br>");
                    }
                    return <>
                        <div dangerouslySetInnerHTML={{ __html: texto }}></div>
                        {item.documentoAsociado && <div>
                            <a target="_blank" href={"https://shub-admin.azurewebsites.net/upload/" + item.documentoAsociado}>Ver adjunto</a>
                        </div>}
                    </>;
                }

            },
            {
                fieldName: nameof(this.state.searchResults.items[0].estado),
                title: I18n.Strings.compromisos.responsables,
                renderField: (item: CompromisoListItem) => this.getResponsables(item)
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].fechaPublicado),
                title: I18n.Strings.compromisos.fecha,
                renderField: (item: CompromisoListItem) => I18n.Strings.formatDate(item.fechaPublicado),
            },
            {
                fieldName: nameof(this.state.searchResults.items[0].fechaColegio),
                title: I18n.Strings.compromisos.aceptado,
                renderField: (item: CompromisoListItem) => <Input
                    onChange={(evt) => {
                        var state = this._cloneStateForSetState();
                        state.searchParams.compromisoAceptar = item;
                        this.setState(state, () => this._performSearch());
                    }}
                    type="checkbox"
                    disabled={item.fechaColegio != undefined
                        || ClientContext.Current.estoyImpersonado
                        || ClientContext.Current.login.endsWith("scholarum.es")
                        || ClientContext.Current.login.endsWith("somosdeliber.com")
                    }
                    style={{ padding: 0, marginLeft: 10 }}
                    id={"aceptado" + item.id}
                    checked={item.fechaColegio != undefined}
                />,
            }
        ];

        return columns;
    }

    protected _getEditionItemUrl(item: CompromisoListItem): string {
        return null;
    }

    protected _getNewItemUrl(): string {
        return null;
    }
}
export const Index = withRouter(IndexComp);